module.exports = "\r\n        <div class=\"inner black-text\">\r\n          <p class=\"black-text\">Copyright 2022</p>\r\n        </div>"


//////////////////
// WEBPACK FOOTER
// J:/Develop/Plumit Maintenance/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main